import {
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';

import { Paginator } from '../../models/paginator';

@Component({
  selector: 'mcrai-paginator',
  template: `<ng-container *ngIf="showPaginator()">
  <div class="mcrai-paginator__buttons">
    <button
      (click)="prevPage()"
      [disabled]="isFirstPage()"
      class="mcrai-paginator__button"
      mcrai-icon-button
    >
      <mcrai-icon color="secondary">arrow_left</mcrai-icon>
    </button>
    <button
      (click)="nextPage()"
      [disabled]="isLastPage()"
      class="mcrai-paginator__button"
      mcrai-icon-button
    >
      <mcrai-icon color="secondary">arrow_right</mcrai-icon>
    </button>
  </div>

  <div class="mcrai-paginator__range">
    {{ getRange() }} ze {{ getCount() }}
  </div>
</ng-container>
`,
  styles: [`.mcrai-paginator{display:flex;justify-content:flex-end;align-items:center;margin-top:2px;margin-bottom:2px}.mcrai-paginator__range{display:flex;justify-content:flex-end;align-items:center;margin-left:5px;font-size:14px}.mcrai-paginator__buttons{display:flex;justify-content:flex-end;align-items:center}.admin .mcrai-paginator__button{padding:0 10px}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent implements OnInit {
  readonly PAGINATOR_CLASS = 'mcrai-paginator';

  private _destroy: Subject<any> = new Subject();

  @Input('paginator') private _paginator: Paginator;

  @Output() prev: EventEmitter<number> = new EventEmitter();
  @Output() next: EventEmitter<number> = new EventEmitter();
  @Output() page: EventEmitter<number> = new EventEmitter();

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.PAGINATOR_CLASS);
  }

  public showPaginator(): boolean {
    return this._paginator && this._paginator.page_count > 1;
  }

  public getRange(): string {
    let lowerLimit = this._paginator.ipp * (this._paginator.page - 1) + 1;
    let upperLimit = this._paginator.ipp * this._paginator.page;

    if (upperLimit > this._paginator.count) {
      upperLimit = this._paginator.count;
    }

    return lowerLimit + ' - ' + upperLimit;
  }

  public nextPage(): void {
    const newPageIndex = this._paginator.page + 1;

    window.scrollTo(0, 0);

    this.next.emit(newPageIndex);
    this.page.emit(newPageIndex);
  }

  public prevPage(): void {
    const newPageIndex = this._paginator.page - 1;

    window.scrollTo(0, 0);

    this.prev.emit(newPageIndex);
    this.page.emit(newPageIndex);
  }

  public isFirstPage(): boolean {
    return this._paginator.page === 1;
  }

  public isLastPage(): boolean {
    return this._paginator.page === this._paginator.page_count;
  }

  public getCount(): string {
    return this._paginator.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
